import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useWindowSize } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

const TabComponent = ({ liveTV_id }) => {
  const router = useRouter();
  const masterConfig = useContext(MasterConfigContext);
  const liveKeys = masterConfig["livetv_page"];
  const tabs = liveKeys?.tabs;

const [activeTab, setActiveTab] = useState(tabs.find((tab) => tab.id === liveTV_id)?.id || tabs[0]?.id);  

// Sync URL with the active tab
  useEffect(() => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (currentTab && router.pathname !== currentTab.url) {
      router.push(currentTab.url, undefined, { shallow: true });
    }
  }, [activeTab, router]);
  const size = useWindowSize();
  let height;
  if (size.width > 1024) {
    height = "454"; // Desktop
  } else if (size.width > 720 && size.width <= 1024) {
    height = "420"; // Tablet
  } else {
    height = "220"; // Mobile
  }

  return (
    <div className="max-w-4xl mx-auto mt-2 font-sans">
      <div className="flex md:flex-wrap  
  rounded-t-md  
  overflow-x-auto md:overflow-visible 
  scroll-smooth no-scrollbar">
  {tabs.map((tab) => (
    <a
  href={process.env.NEXT_PUBLIC_WEBSITE_URL + tab.url}
  key={tab.id}
  onClick={() => setActiveTab(tab.id)}
  className={`w-[150px] flex-shrink-0 flex md:flex-1 flex-row items-center justify-center gap-2
    py-3 px-4 font-semibold text-center cursor-pointer transition-all duration-300 rounded-t-md 
    ${
      activeTab === tab.id
        ? "bg-[#EA222A] text-white border-[#EA222A] shadow border "
        : "bg-white text-gray-700 hover:bg-gray-200 border "
    }
  `}
>
  <img
    src={activeTab === tab.id ? tab.logo_active : tab.logo}
    className="w-8 md:w-10"
  />
  <span className="whitespace-nowrap">{tab.label}</span>
</a>

  ))}
</div>


      {/* Tab Content */}

      {tabs.map(
        (tab) =>
          activeTab === tab.id && (
            <iframe
              key={tab.id}
              title={tab.label}
              className="w-full aspect-[16/9] "
              allowFullScreens
              id={`livetv-${tab.id}`}
              // width={"100%"}
              // height={height}
              src={tab.liveUrl}
              scrolling="no"
              frameBorder="0"
              allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope"
              mozallowfullscreen
              webkitallowfullscreen
            ></iframe>
          )
      )}
      
    </div>
  );
};

export default TabComponent;
